import { render, staticRenderFns } from "./UserMngtList.vue?vue&type=template&id=a96beb34"
import script from "./UserMngtList.vue?vue&type=script&lang=js"
export * from "./UserMngtList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports